// MockChildComponentForTesting.vue
<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'MockChildComponent',
  mounted() {
    throw new Error('Error message in mockchildcomponent.');
  }
};
</script>
